import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from "@angular/core";
import { IVehicleQueryOptions } from "@app/interfaces/IVehicleQueryOptions";
import { IVehicle } from "@interfaces/IVehicle";
import { TranslationService } from "@services/translation.service";
import { VehicleService } from "@services/vehicle.service";
import "./v-vehicle-autocomplete.component.scss";

@Component({
    selector: "v-vehicle-autocomplete",
    template: require('./v-vehicle-autocomplete.component.html')
})
export class VVehicleAutocompleteComponent implements OnChanges {
    @Input() vehicle: IVehicle;
    @Input() selectedVehicleId: string;
    @Output() selectedVehicleIdChange: EventEmitter<string> = new EventEmitter();
    @Input() queryOptions: IVehicleQueryOptions;

    @Output() vehicleSelected = new EventEmitter<IVehicle>();
    @Output() clear = new EventEmitter<void>();

    @Input() label: string = this.translationService.t("Common.Vehicle");
    @Input() placeholder: string = this.translationService.t("VehicleAutoComplete.SelectVehicle");

    @ViewChild('autoCompleteInput') autoCompleteInput: any;

    // ---

    text: string = '';
    vehiclePromise: angular.IPromise<IVehicle[]>;

    constructor(
        private readonly translationService: TranslationService,
        private readonly vehicleService: VehicleService) {
    }

    ngOnChanges() {
        if (this.selectedVehicleId) {
            this.loadData();
        }
    }

    onCleared(): void {
        this.text = '';
        this.selectedVehicleId = null;
        this.selectedVehicleIdChange.emit(null);
        this.clear.emit();
    }

    onFocus() {
        this.loadData();
    }

    onTextChanged(text: string) {
        this.text = text;

        if ((!text || text.trim() === '') && this.selectedVehicleId) {
            this.selectedVehicleId = null;
            this.selectedVehicleIdChange.emit(null);
            this.clear.emit();
        }
    }

    onVehicleClicked(vehicle: IVehicle) {
        this.text = vehicle.ShortReg;
        this.vehicleSelected.emit(vehicle);
    }

    vehicleFilter = (vehicle: IVehicle, text: string): boolean => {
        return this.vehicleService.vehicleSearchPredicate(vehicle, text);
    }

    // ---

    private loadData() {
        this.vehiclePromise = this.vehicleService.getVehiclesBasic(this.queryOptions);
    }
}
